import React from 'react'
import './cryptoinvesting.scss';

const Cryptoinvesting = () => {
    return (
        <section className='main_Power' id='problem'>
            <div className='innner_power'>
                <img src='\assets\shade.png' className='shade_img' />
                <div className='custom-container'>
                    <div className='nnermore'>
                        <div>
                            <button>
                                <img src='\assets\warning.svg' />
                                Problem
                            </button>
                            <h2>Traditional Crypto
                                Investing is Broken</h2>
                            <ul class="my-list">
                                <li>Most investors put all capital into a single token → risky and fragile.</li>
                                <li>Sudden market shifts can erase years of gains overnight.</li>
                            </ul>
                        </div>
                        <div>
                            <img src='\assets\coinsimg.png'className='img-fluid'  />
                        </div>

                    </div>

                </div>
            </div>

        </section>
    )
}

export default Cryptoinvesting
